import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-1x4c4wl-0"
})(["display:block;border-radius:", ";box-shadow:", " 0 0 0 2px;"], function (_ref) {
  var theme = _ref.theme;
  return theme.borderRadius;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.uiM;
});
export var Header = styled.div.withConfig({
  displayName: "partials__Header",
  componentId: "sc-1x4c4wl-1"
})(["display:flex;padding:12px 12px 12px 18px;border-bottom:1px solid ", ";", ";svg{margin-right:6px;vertical-align:sub;}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.borderColor;
}, getFont(0));
export var Body = styled.div.withConfig({
  displayName: "partials__Body",
  componentId: "sc-1x4c4wl-2"
})(["display:block;", " ", ""], function (_ref4) {
  var withTopPadding = _ref4.withTopPadding;
  return withTopPadding ? 'padding-top: 12px;' : '';
}, function (_ref5) {
  var withMinHeight = _ref5.withMinHeight;
  return withMinHeight ? 'min-height: 180px;' : '';
});